import { render, staticRenderFns } from "./ShukkaJunbiHikiwatashi.vue?vue&type=template&id=2132cfff"
import script from "./ShukkaJunbiHikiwatashi.vue?vue&type=script&lang=js"
export * from "./ShukkaJunbiHikiwatashi.vue?vue&type=script&lang=js"
import style0 from "./ShukkaJunbiHikiwatashi.vue?vue&type=style&index=0&id=2132cfff&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports